import React, { useContext, useEffect, useState } from 'react';
import {FormDataContext} from "../../contexts/FormDataContext";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box, Button,
  Checkbox,
  FormControlLabel, InputAdornment,
  TextField,
  Typography,
} from '@mui/material';
import { ExpandMore } from '@mui/icons-material';
import { SectionHeading } from '../SectionHeading';
import { SectionPaper } from '../SectionPaper';


export const Locations = () => {
  const [nationalLocations, setNationalLocations] = useState([]);
  const [originalNationalLocations, setOriginalNationalLocations] = useState([]);
  const [internationalLocations, setInternationalLocations] = useState([]);
  const [filterTerm, setFilterTerm] = useState('');
  const [isNationalExpanded, setIsNationalExpanded] = useState(false);

  const {
    locations,
    selectedLocationsAll,
    setSelectedLocationsAll,
    selectedLocations,
    setSelectedLocations,
    preferencesFormDisabled,
    setIsFormDataChanged,
    // initialPreferencesData,
    intakeDataLoaded,
    initialLocationsAll,
  } = useContext(FormDataContext);

  useEffect(() => {
    if (locations.length > 0) {
      const filteredNational = locations.filter(
        location => !parseInt(location.international)
      );
      setNationalLocations(filteredNational);
      setOriginalNationalLocations(filteredNational);
      setInternationalLocations(locations.filter(
        location => parseInt(location.international)
      ));
    }
  }, [locations]);

  const requestSearch = (event) => {
    const searchedVal = event.target.value;
    setFilterTerm(searchedVal);
    if (searchedVal.length > 0) {
      const clonedOriginalNationalLocations = originalNationalLocations.map(
        location => Object.assign({}, location)
      );
      const filteredNationalLocations = clonedOriginalNationalLocations.filter(location => {
        const isNameMatch = location.extendedName.toLowerCase().includes(searchedVal.toLowerCase());
        let isStateNameMatch = false;
        if (location.stateName) {
          isStateNameMatch = location.stateName.toLowerCase().includes(searchedVal.toLowerCase());
        }
        return isNameMatch || isStateNameMatch;
      });
      setNationalLocations(filteredNationalLocations);
    } else {
      setNationalLocations(originalNationalLocations);
    }
  };

  const handleClearFilter = () => {
    setFilterTerm('');
    setNationalLocations(originalNationalLocations);
  };

  const handleLocationChange = locationId => {
    if (selectedLocations.includes(locationId)) {
      setSelectedLocations(selectedLocations.filter(
        selectedLocationId => selectedLocationId !== locationId
      ));
    } else {
      setSelectedLocations([...selectedLocations, locationId]);
    }
    setIsFormDataChanged(true);
  };
  const toggleExpanded = accordionId => {
    if (isNationalExpanded) {
      setIsNationalExpanded(false);
    } else {
      setIsNationalExpanded(true);
    }
  };

  const handleAllLocationsChange = event => {
    const isChecked = event.target.checked;
    setSelectedLocationsAll(isChecked);
    setIsFormDataChanged(true);
  };

  const getSelectedCount = locations => {
    let locationsSelectedText = '';
    let locationsSelectedCount = 0;
    locations.map(location => {
      if (selectedLocations.includes(location.id)) {
        locationsSelectedCount++;
      }
    });
    if (locationsSelectedCount > 0) {
      locationsSelectedText = locationsSelectedCount + ' selected';
    }
    return locationsSelectedText;
  };

  return (
    <>
      <SectionHeading>
        Locations
      </SectionHeading>
      <SectionPaper>
        {intakeDataLoaded &&
          <FormControlLabel control={
              <Checkbox
                onChange={handleAllLocationsChange}
                disabled={preferencesFormDisabled}
                defaultChecked={initialLocationsAll}
              />
          } label="All locations"/>
        }
      </SectionPaper>
      <Box sx={{marginTop: '15px'}}>
        <TextField
          disabled={preferencesFormDisabled}
          onChange={(searchVal) => requestSearch(searchVal)}
          label="Filter national locations"
          value={filterTerm}
          fullWidth
          InputProps={{
            endAdornment: (
              filterTerm && (
                <InputAdornment position="end">
                  <Button
                    variant="contained"
                    onClick={handleClearFilter}
                  >
                    Clear filter
                  </Button>
                </InputAdornment>
              )
            ),
          }}
        />
      </Box>

      <Box sx={{marginY: '6px'}}>
        <Accordion expanded={filterTerm ? true : isNationalExpanded}>
          <AccordionSummary
            expandIcon={<ExpandMore/>}
            aria-controls={`national-content`}
            id={`national-header`}
            onClick={toggleExpanded}
          >
            <Box sx={{ display: 'flex', width: '100%', justifyContent: 'space-between' }}>
              <Typography>
                National
              </Typography>
              <Typography
                sx={{ flexShrink: 0, textAlign: 'right', marginRight: '10px', opacity: 0.85 }}
                variant={'subtitle1'}
              >
                {getSelectedCount(nationalLocations)}
              </Typography>
            </Box>
          </AccordionSummary>
          <AccordionDetails>
            {nationalLocations.map(location => (
              <div key={`location${location.id}`}>
                <FormControlLabel key={`label${location.id}`} control={
                  <Checkbox
                    checked={selectedLocations.includes(location.id)}
                    onChange={() => handleLocationChange(location.id)}
                    disabled={preferencesFormDisabled}
                  />
                } label={location.extendedName} />
              </div>
            ))}
            {filterTerm && nationalLocations.length === 0 &&
              <Typography>
                No National locations match this filter.
              </Typography>
            }
          </AccordionDetails>
        </Accordion>
      </Box>

      <Box sx={{marginY: '6px'}}>
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMore/>}
            aria-controls={`international-content`}
            id={`international-header`}
          >
            <Box sx={{ display: 'flex', width: '100%', justifyContent: 'space-between' }}>
              <Typography>
                International
              </Typography>
              <Typography
                sx={{ flexShrink: 0, textAlign: 'right', marginRight: '10px', opacity: 0.85 }}
                variant={'subtitle1'}
              >
                {getSelectedCount(internationalLocations)}
              </Typography>
            </Box>
          </AccordionSummary>
          <AccordionDetails>
            {internationalLocations.map(location => (
              <div key={`location${location.id}`}>
                <FormControlLabel key={`label${location.id}`} control={
                  <Checkbox
                    checked={selectedLocations.includes(location.id)}
                    onChange={() => handleLocationChange(location.id)}
                    disabled={preferencesFormDisabled}
                  />
                } label={location.extendedName} />
              </div>
            ))}
          </AccordionDetails>
        </Accordion>
      </Box>
    </>
  );
};
